import { API_ROUTES } from '@app/common';
import type {
  UserSubscription,
  InitiatePaymentResponse,
  PaymentRecord,
  PurchasablePlan,
} from '@app/common';
import { apiFetch } from './index';

export type {
  PlanType,
  PurchasablePlan,
  SubscriptionStatus,
  TierLimits,
  UserSubscription,
  InitiatePaymentResponse,
  PaymentRecord,
} from '@app/common';

export const getMySubscription = (): Promise<UserSubscription> =>
  apiFetch<UserSubscription>(API_ROUTES.SUBSCRIPTION_ME);

export const cancelSubscription = (): Promise<null> =>
  apiFetch<null>(API_ROUTES.SUBSCRIPTION_CANCEL, { method: 'POST' });

export const initiatePayment = (plan: PurchasablePlan): Promise<InitiatePaymentResponse> =>
  apiFetch<InitiatePaymentResponse>(API_ROUTES.PAYMENT_INITIATE, {
    method: 'POST',
    body: JSON.stringify({ plan }),
  });

export const getPaymentHistory = (): Promise<PaymentRecord[]> =>
  apiFetch<PaymentRecord[]>(API_ROUTES.PAYMENT_HISTORY);
